import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/mobile.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode geçici olarak kapatıldı (findDOMNode uyarıları için)
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
